import { Routes } from '../../../core/routes';

export const getPermissionRoutes = (): Record<string, string> => {
  return {
    Users: Routes.accessUsers,
    'Service Accounts': Routes.accessServiceAccounts,
    Groups: Routes.accessGroups,
  };
};
